"use client";

import Image from "next/image";

import { useTranslation } from "@/app/i18n/client";

interface NotFoundComponentProps {
  notFoundText?: string;
  backHomeText?: string;
  onAction?: () => void;
}

const InternalServerError = ({
  notFoundText,
  backHomeText,
  onAction,
}: NotFoundComponentProps) => {
  const { t } = useTranslation("error");

  const text1 = notFoundText || t("error500.text1");
  const text2 = notFoundText || t("error500.text2");
  const textBackHome = backHomeText || t("load-again");

  return (
    <div className="flex flex-col items-center gap-y-6 py-40 text-center">
      <Image
        src="https://d31jk6ljx7wihh.cloudfront.net/images/error/error500.webp"
        width={112}
        height={64}
        alt="error 500 image"
      />
      <div className="px-4">
        <h2 className="text-xl md:text-2xl">{text1}</h2>
        <h3 className="text-xl md:text-2xl">{text2}</h3>
      </div>
      <button
        type="button"
        className="cursor-pointer rounded-lg border border-stroke-active px-3 py-4 text-base text-stroke-active hover:bg-stroke-active hover:text-white"
        onClick={onAction}
      >
        {textBackHome}
      </button>
    </div>
  );
};

export default InternalServerError;
